export const MAIN_MENU_REWRITES = {
	'bs-on-map': 'home-map',
	'base-stations-edit': 'base-stations',
	'add-base-station': 'base-stations',
	'paas': 'base-stations',
	'baselines-edit': 'baselines',
	'add-baseline': 'baselines',
	'cnet-constructor-add': 'cnet-constructor',
	'cnet-constructor-edit': 'cnet-constructor',
	'settings-type': 'settings',
	'settings-sub-network-edit': 'settings',
	'stats-type': 'stats',
};
